import React, { Component } from 'react'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import Icon from "../icon/icon.component.jsx";
import TemplateSelector from "../template/selection.component.jsx";
import ActionButton from "../button/actionbutton.component.jsx";
const uuidv4 = require('uuid/v4')

class InlineEditTemplate extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            templateId: this.props.value,
            templateName: '',
            templateType: this.props.templateType || '',
            endPoint: this.props.endPoint || '',
            field: this.props.field || '',
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function () { },
        }
        this.handleUserSelectChange = this.handleUserSelectChange.bind(this)
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
    }


    componentWillReceiveProps(nextProps) {
        const currentTemplateId = this.state.templateId
        this.setState({
            templateId: nextProps.value,
            endPoint: nextProps.endPoint || '',
            templateType: nextProps.templateType || '',
            field: nextProps.field || '',
        }, () => {
            if (currentTemplateId !== this.state.templateId) {
                this.loadName()
            }
        })
    }

    loadName() {
        if (!this.state.templateId) {
            return
        }
        AppContext.getApiClient().get('/documents/' + this.state.templateId).then(res => {
            this.setState({
                templateName: res.attributes.name,
            })
        })
    }

    componentDidMount() {
        if (!this.state.templateName) {
            this.loadName()
        }
    }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    handleUserSelectChange(userId) {
        this.setState({
            sellerId: userId,
        })
    }

    save(event) {
        event.preventDefault()
        AppContext.getApiClient().patch(this.state.endPoint, {
            [this.state.field]: this.state.templateId,
        }).then((r) => {
            this.setState({
                editMode: false,
            })
            this.loadName()
        })
    }

    render() {
        let templateName = this.state.templateName
        if (this.state.editable) {
            let link = <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
                {templateName} <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} />
            </a>
            templateName = <span>
                {link}
                <div className={"dropdown-menu p-4 " + (this.state.editMode ? 'show' : '')} style={{ width: '350px' }}>
                    <div className="w-100 m-0">
                        <TemplateSelector
                            documentType={this.state.templateType}
                            value={this.state.templateId}
                            onChange={id => { this.setState({ templateId: id }) }}
                            className="form-control"
                        />
                    </div>
                    <p className="m-0 pt-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                            <Icon value={"arrow-left"} />
                        </button>
                        <ActionButton className="btn btn-sm btn-outline-primary ml-2" onClick={this.save}>
                            <Icon value={"save"} />
                        </ActionButton>
                    </p>
                </div>
            </span>
        }

        return templateName
    }

}

export default InlineEditTemplate





// WEBPACK FOOTER //
// ./src/common/inline-edit/template.component.jsx